<template>
  <Panel class="intro-y" :title="$t('text.customerInfoOther')">
    <div class="flex flex-col sm:flex-row">
      <p class="mr-auto text-gray-600">{{ $t('text.registrationNumber') }}</p>
      <p class="font-medium">{{ customer.registrationNumber }}</p>
    </div>
    <div class="flex flex-col sm:flex-row mt-5">
      <p class="mr-auto text-gray-600">{{ $t('text.familyName') }}</p>
      <p class="font-medium">{{ customer.familyName }}</p>
    </div>
    <div class="flex flex-col sm:flex-row mt-5">
      <p class="mr-auto text-gray-600">{{ $t('text.degreeOfEducation') }}</p>
      <p class="font-medium">{{ customer.degree?.name }}</p>
    </div>
    <div class="flex flex-col sm:flex-row mt-5">
      <p class="mr-auto text-gray-600">{{ $t('text.isMarried') }}</p>
      <p class="font-medium">{{ customer.isMarried ? $t('text.yes') : $t('text.no') }}</p>
    </div>
    <div class="flex flex-col sm:flex-row mt-5">
      <p class="mr-auto text-gray-600">{{ $t('text.familySize') }}</p>
      <p class="font-medium">{{ customer.familySize }}</p>
    </div>
  </Panel>
</template>

<script>
import Panel from '@/components/ui/Panel';

export default {
  props: {
    customer: Object,
  },
  components: { Panel },
};
</script>
